import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="weights-block"
export default class extends Controller {
  
  static targets = ["input", "submit"]
  
  get values() {
    return this.inputTargets.map(input => input.value)
  }

  get hasValue() {
    return this.values.some(value => !isNaN(parseFloat(value)))
  }
  
  connect() {
    this.element.dataset.action = "input->weights-block#check"
  }

  check() {
    this.submitTarget.disabled = !this.hasValue
  }

}
